<mat-tab-group class="with-title-headers" mat-align-tabs="end">
  @for (tab of field.fieldGroup; track tab.key) {
    <mat-tab>
      <ng-template mat-tab-label>
        <div class="d-flex w-100 justify-content-between align-items-center">
          <span class="label-tab">{{ (tab.props?.label | apmTranslate) || '' }}</span>
          <div class="icon-error">
            @if (!isValid(tab?.fieldGroup)) {
              <apm-icon size="xs" icon="aa_alert_filter"> </apm-icon>
            }
          </div>
        </div>
      </ng-template>
      <ng-template matTabContent>
        <div class="tab-content">
          <formly-field [field]="tab"></formly-field>
        </div>
      </ng-template>
    </mat-tab>
  }
</mat-tab-group>
